import { registerPlugin, type PluginListenerHandle } from "@capacitor/core";

export interface NativeMidiDevice {
  id: string;
  name: string;
  manufacturer: string;
  /** "usb" | "bluetooth" | "virtual" — already normalized by the Swift side. */
  transport: string;
  connected: boolean;
}

export interface NativeMidiMessageEvent {
  /** Source device id (matches `NativeMidiDevice.id`). */
  id: string;
  /** Raw 3-byte MIDI message (status, data1, data2). */
  data: number[];
}

export interface NativeMidiStateChangeEvent {
  id: string;
  state: "connected" | "disconnected";
}

export interface NativeMidiPlugin {
  listDevices(): Promise<{ devices: NativeMidiDevice[] }>;
  setEnabled(opts: { id: string; enabled: boolean }): Promise<void>;
  rescan(): Promise<void>;
  /** Present the native CoreAudioKit Bluetooth MIDI pairing UI. */
  presentBluetoothPairingUI(): Promise<void>;
  addListener(
    eventName: "midiMessage",
    listener: (event: NativeMidiMessageEvent) => void,
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: "stateChange",
    listener: (event: NativeMidiStateChangeEvent) => void,
  ): Promise<PluginListenerHandle>;
  removeAllListeners(): Promise<void>;
}

export const NativeMidi = registerPlugin<NativeMidiPlugin>("MidiPlugin");
